'use strict';

var Enhancer = require('./enhancer');

module.exports = function (ComposedComponent /*: constructor*/) {
  return Enhancer(ComposedComponent);
};
module.exports.Plugins = require('./plugins');
module.exports.PrintStyleSheet = require('./components/print-style-sheet');
module.exports.Style = require('./components/style');
module.exports.getState = require('./get-state');
module.exports.keyframes = require('./keyframes');


//////////////////
// WEBPACK FOOTER
// ./~/@jimpick/spectacle/~/radium/lib/index.js
// module id = 25
// module chunks = 2